import { render } from "./AppBtn.vue?vue&type=template&id=059514b2&scoped=true"
import script from "./AppBtn.vue?vue&type=script&lang=js"
export * from "./AppBtn.vue?vue&type=script&lang=js"

import "./AppBtn.vue?vue&type=style&index=0&id=059514b2&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-059514b2"]])

export default __exports__